import { ContentfulApiService } from "../services/contenful/contentful-api.service";

export function initializeContentful(
    contentfulApiService: ContentfulApiService
) {
    return () => contentfulApiService.initialize();
}
